const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'checkin_moreinfo',
    viewClass: require('./view'),

    methods: {
        showCheckinMoreInfo(show) {
            this.showCheckinMoreInfo(show);
        },
    },

});
